<template>
    <div>
        <div v-if="loading">Loading Recently Watched Lessons...</div>

        <VueSlickCarousel v-bind="settings" v-if="slides.length > 0">

            <div
                v-for="slide in slides" :key="slide.id"
                v-if="slide.tutorial !== null && slide.tutorial.hidden !== 1">
                <a
                    :href="'tutorial/' + slide.tutorial.slug + '/' + slide.lesson.tutorial_order">
                    <div class="slide-frame">
                        <div class="days-ago">
                            <span>Lesson {{slide.lesson.tutorial_order}}</span>,
                            {{convertDate(slide.created_at)}}
                        </div>
                        <img :src="'/storage/tutorial_thumbnails/' + slide.tutorial.thumbnail">
                    </div>
                </a>
            </div>

        </VueSlickCarousel>
    </div>
</template>

<script>
import VueSlickCarousel from 'vue-slick-carousel'
import 'vue-slick-carousel/dist/vue-slick-carousel.css';

export default {
    components: { VueSlickCarousel },
    data () {
        return {
            loading: true,
            slideNum: 12, // Number of slides to load
            slides: [],
            settings: {
                dots: true,
                focusOnSelect: true,
                infinite: true,
                speed: 500,
                slidesToShow: 4,
                slidesToScroll: 4,
                touchThreshold: 5,
                responsive: [
                    {
                        "breakpoint": 1024,
                        "settings": {
                            "slidesToShow": 3,
                            "slidesToScroll": 3,
                            "infinite": true,
                            "dots": true
                        }
                    },
                    {
                        "breakpoint": 600,
                        "settings": {
                            "slidesToShow": 2,
                            "slidesToScroll": 2,
                            "initialSlide": 2
                        }
                    },
                    {
                        "breakpoint": 480,
                        "settings": {
                            "slidesToShow": 1,
                            "slidesToScroll": 1,
                            "arrows": false
                        }
                    }
                ]
            }
        }
    },
    async mounted() {

        // Save some mobile data, fetch fewer thumbnails if on mobile device
        if (this.isMobile()) {
            this.slideNum = 6;
        }

        await axios.get('/lessons/recently-watched/' + this.slideNum)
            .then(response => {
                this.slides = response.data;
                this.loading = false;
            })
    },

    methods: {
        isMobile() {
            if(/Android|webOS|iPhone|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
                return true
            } else {
                return false
            }
        },

        convertDate: function (date) {

            /**
             * Workaround for dates in Safari ECMAscript issues
             * iPhones and Safari, am I right?
             */
            let today;
            let isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);

            if (/iPhone|iPod|iPad|Opera Mini/i.test(navigator.userAgent) || isSafari) {

                // Parse today's date
                let newToday = new Date().toISOString().slice(0,10)
                today = new Date(newToday.replace(/-/g, '/'));

                // Parse Date viewed
                //let newDate = new date.toISOString().slice(0,10)
                date = new Date(date.replace(' ', 'T'));
            } else {
                today = new Date().toISOString().slice(0,10)
            }

            let date1 = new Date(date);
            let date2 = new Date(today);

            // To calculate the time difference of two dates
            let differenceInTime = date2.getTime() - date1.getTime();

            // To calculate the no. of days between two dates
            let differenceInDays = differenceInTime / (1000 * 3600 * 24);

            if (isNaN(differenceInDays)) {
                return 'Over 1 Year ago'
            }

            //To display the final no. of days (result)
            if (Math.ceil(differenceInDays) <= 0) {
                return 'Today';
            } else if (Math.ceil(differenceInDays) > 365) {
                return 'Over 1 Year ago';
            } else {
                return Math.ceil(differenceInDays) + ' days ago';
            }
        }
    }
}
</script>
